import * as React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { PrivateRoute } from './PrivateRoute'
import * as RT from './config/routeType'
import Map from './components/MapboxGL'
import NotFoundPage from './containers/NotFoundPage'
import AppPage from './containers/AppPage'
import GenerateReportContainer from './containers/GenerateReport/GenerateReportContainer'
import AppBarMenu from './components/AppBar/AppBar'
import TreeManagementPage from './components/TreeManagement'
import ManagementTable from './containers/ManagementTable'
import ManagementPage from './containers/ManagementPage'
// import CheckConnection from './containers/CheckConnection'
import TreeRegistrationForm from './components/TreeRegistrationForm'
import ManagementInfo from './components/ManagementInfo'
import ForgotPasswordPage from './containers/ForgotPasswordPage'
import ProfilePage from './containers/ProfilePage'
import SignUpPage from './containers/SignUpPage'
import AuthorizeAccountPage from './containers/AuthorizeAccountPage'
import ResetPasswordPage from './containers/ResetPasswordPage'
import InformationPage from './containers/InformationPage'
import { verificated } from './redux/slices/Auth/login'
import { isUserVerify } from './services'

export default function App() {
  const dispatch = useDispatch()
  const authenticated = useSelector(state => state.login.authenticated)
  const isAuth = authenticated?.auth
  const roleUser = authenticated?.user?.rol
  const isAdmin = roleUser?.includes('administrador')
  const tokenLocal = window.localStorage.getItem('arbolQR_Token')

  React.useEffect(() => {
    if (!Boolean(tokenLocal)) return
    isUserVerify(`Bearer ${tokenLocal}`)
      .then(userLocal => {
        if (!userLocal?.auth) {
          window.localStorage.removeItem('arbolQR_Token')
          dispatch(verificated(null))
        } else dispatch(verificated(userLocal))
      })
      .catch(err => console.log('err :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenLocal])

  return (
    <main>
      <AppBarMenu authenticated={authenticated} />
      <Routes>
        {/* <Route element={<CheckConnection />}> */}
        <Route path={`${RT.MAIN}`} element={<AppPage />}>
          <Route index element={<Navigate to={RT.TREE} />} />
          <Route path={RT.TREE} element={<Map allOption={isAdmin} isAuth={isAuth} />}>
            <Route path=":treeId" element={<div style={{ display: 'none' }} />} />
          </Route>
          <Route element={<PrivateRoute isAllowed={isAuth} />}>
            <Route
              path={RT.GENERATE_REPORT}
              element={
                <PrivateRoute isAllowed={isAuth && isAdmin} redirectTo={RT.MAIN}>
                  <GenerateReportContainer />
                </PrivateRoute>
              }
            />
            <Route path={RT.MANAGEMENT_TREE} element={<ManagementPage />}>
              <Route
                path={RT.TREE}
                element={
                  <Map widthMap="50%" allOption={isAdmin} isAuth={isAuth} minimap />
                }>
                <Route index element={<ManagementInfo roleUser={roleUser} />} />
                <Route path={RT.REGISTER_TREE} element={<TreeRegistrationForm />} />
                <Route
                  path=":treeId"
                  element={<TreeManagementPage roleUser={roleUser} />}
                />
              </Route>
              <Route
                path={RT.TABLE_RECORDS}
                element={
                  <PrivateRoute isAllowed={isAuth && isAdmin} redirectTo={RT.MAIN}>
                    <ManagementTable />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path={RT.PROFILE} element={<ProfilePage />} />
          </Route>
          <Route element={<PrivateRoute isAllowed={!isAuth} redirectTo={RT.PROFILE} />}>
            <Route path={RT.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
            <Route path={RT.REGISTER_USER} element={<SignUpPage />} />
            <Route
              path={`${RT.AUTH_RESET_PASSWORD}/:token`}
              element={<ResetPasswordPage />}
            />
          </Route>
          <Route
            path={`${RT.AUTH_AUTHORIZE_USER}/:token`}
            element={<AuthorizeAccountPage />}
          />
          <Route path={RT.INFORMATION} element={<InformationPage />} />
          <Route path={RT.NOT_FOUND_404} element={<NotFoundPage />} />
        </Route>
        {/* </Route> */}
      </Routes>
    </main>
  )
}
